(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monarca-cart"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root, isUpdating = false;

  document.addEventListener('DOMContentLoaded', init);
  if(document.readyState !== 'loading') init();

  function init(){
    root = document.getElementById('monarca-cart');
    if(!root) return;
    bindQtyButtons();
    bindQtyInputs();
    bindRemoveButtons();
    bindClearAll();
    bindPromo();
  }

  function bindQtyButtons(){
    root.querySelectorAll('.mc-qty-btn').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        if(isUpdating) return;
        var wrap = btn.closest('.mc-qty');
        var input = wrap.querySelector('.mc-qty-input');
        var key = input.dataset.key;
        var currentQty = parseInt(input.value) || 1;
        var delta = parseInt(btn.dataset.delta) || 0;
        var newQty = Math.max(0, currentQty + delta);
        updateLineQty(key, newQty);
      });
    });
  }

  function bindQtyInputs(){
    root.querySelectorAll('.mc-qty-input').forEach(function(input){
      input.addEventListener('change', function(){
        if(isUpdating) return;
        var key = input.dataset.key;
        var newQty = Math.max(0, parseInt(input.value) || 0);
        updateLineQty(key, newQty);
      });
    });
  }

  function bindRemoveButtons(){
    root.querySelectorAll('.mc-remove').forEach(function(btn){
      btn.addEventListener('click', function(e){
        e.preventDefault();
        if(isUpdating) return;
        var key = btn.dataset.key;
        updateLineQty(key, 0);
      });
    });
  }

  function bindClearAll(){
    var btn = document.getElementById('mc-clear-all');
    if(!btn) return;
    btn.addEventListener('click', function(){
      if(isUpdating) return;
      if(!confirm('¿Vaciar todo el carrito?')) return;
      isUpdating = true;
      root.classList.add('is-updating');
      fetch('/cart/clear.js', {method:'POST'})
        .then(function(){ window.location.reload(); })
        .catch(function(){ isUpdating = false; root.classList.remove('is-updating'); });
    });
  }

  function bindPromo(){
    var input = document.getElementById('mc-promo-input');
    var btn = document.getElementById('mc-promo-btn');
    if(!input || !btn) return;
    function apply(){
      var code = (input.value || '').trim();
      if(!code) return;
      // Shopify applies discount codes at checkout via a query param
      window.location.href = '/checkout?discount=' + encodeURIComponent(code);
    }
    btn.addEventListener('click', apply);
    input.addEventListener('keydown', function(e){
      if(e.key === 'Enter'){ e.preventDefault(); apply(); }
    });
  }

  function updateLineQty(key, quantity){
    isUpdating = true;
    root.classList.add('is-updating');
    var item = root.querySelector('.mc-item[data-line-key="' + key + '"]');
    if(item && quantity === 0) item.classList.add('is-removing');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      window.location.reload();
    })
    .catch(function(){
      isUpdating = false;
      root.classList.remove('is-updating');
      if(item) item.classList.remove('is-removing');
      alert('No se pudo actualizar el carrito. Intenta de nuevo.');
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monarca-home"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root;
  document.addEventListener('DOMContentLoaded', init);
  if(document.readyState !== 'loading') init();

  function init(){
    root = document.getElementById('monarca-home');
    if(!root) return;
    loadFonts();
    bindDrawer();
  }

  function loadFonts(){
    if(document.querySelector('link[href*="Anton"]')) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Anton&family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,500;0,9..144,700;1,9..144,400;1,9..144,500&family=Inter+Tight:wght@400;500;600;700;800&family=Caveat:wght@400;700&display=swap';
    document.head.appendChild(l);
  }

  function bindDrawer(){
    var btn = document.getElementById('mh-menu-btn');
    var drawer = document.getElementById('mh-drawer');
    var closeBtn = document.getElementById('mh-drawer-close');
    var backdrop = document.getElementById('mh-drawer-backdrop');
    if(!btn || !drawer) return;
    function open(){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); }
    function close(){ drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); }
    btn.addEventListener('click', open);
    if(closeBtn) closeBtn.addEventListener('click', close);
    if(backdrop) backdrop.addEventListener('click', close);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["monarca-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Inject Google Fonts if not present
  if(!document.querySelector('link[href*="Anton"]')){
    var l = document.createElement('link');
    l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Anton&family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,500;0,9..144,700;1,9..144,400;1,9..144,500&family=Inter+Tight:wght@400;500;600;700;800&family=Caveat:wght@400;700&display=swap';
    document.head.appendChild(l);
  }

  var qty = 1;
  var currentColor = '';
  var currentPack = '';
  var currentVariantId = '';
  var currentVariantPrice = 0;
  var variantMap = [];

  // Pack map: { qty (Number) -> { variantId, packValue, price, perUnit } }
  var packsByQty = {};
  var packQtyValues = []; // sorted: [1, 2, 3]
  var maxPackQty = 1;
  var minPackQty = 1;

  // Upsell
  var upsellVariantId = 0;
  var upsellPrice = 0;
  var upsellEnabled = false;
  var upsellQty = 1;

  // Color slots (multi-color bundle)
  var availableColors = [];
  var colorThumbs = {};
  var slotColors = [];
  var slotLabelPrefix = 'Reloj';

  var qtyEl, ctaPriceEl, stickyPriceEl, stickyColorEl, stickyEl, mainCtaEl, variantInput, qtyMinusBtn, qtyPlusBtn;

  function fmt(cents){
    var pesos = cents / 100;
    return '$' + Math.round(pesos).toLocaleString('es-CO');
  }

  function init(){
    qtyEl = document.getElementById('m-qty');
    ctaPriceEl = document.getElementById('m-cta-price');
    stickyPriceEl = document.getElementById('m-sticky-price');
    stickyColorEl = document.getElementById('m-sticky-color');
    stickyEl = document.getElementById('m-sticky');
    mainCtaEl = document.getElementById('m-main-cta');
    variantInput = document.getElementById('m-variant-id');

    var dataEl = document.getElementById('m-variants-data');
    if(dataEl){
      try { variantMap = JSON.parse(dataEl.textContent); } catch(e){}
    }

    var root = document.querySelector('.monarca-pdp');
    if(root){
      currentColor = root.dataset.currentColor || '';
      currentPack = root.dataset.currentPack || '';
      currentVariantId = root.dataset.currentVariantId || '';
      currentVariantPrice = parseInt(root.dataset.basePrice) || 0;
    }

    buildPackMap();
    buildColorList();
    bindPacks();
    bindColors();
    bindFAQ();
    bindQtyButtonsRef();
    bindSticky();
    bindGallery();
    bindDescription();
    bindViewers();
    bindCountdown();
    bindVideos();
    bindUpsell();
    bindSecondaryCTAs();
    bindMainCta();
    bindMenuButton();
    syncQtyFromPack();
    renderSlots();
    refreshTotal();
    // Initial cart sync so Releasit's button is accurate even if the customer
    // clicks it without changing any selection.
    scheduleCartSync();
    hideReleasitDuplicateButton();
  }

  // Releasit's own "Pago Contra entrega" button on the PDP is hidden via CSS
  // (see the rule targeting #rsi_buy_now_button at the top of this file).
  // No JS action needed here — kept as a no-op so the init() call chain stays
  // stable across theme edits.
  function hideReleasitDuplicateButton(){
    // intentionally empty — handled by CSS
  }

  function bindQtyButtonsRef(){
    qtyMinusBtn = document.querySelector('.m-qty-control .m-qty-btn:first-child');
    qtyPlusBtn = document.querySelector('.m-qty-control .m-qty-btn:last-child');
    updateQtyButtons();
  }

  function buildColorList(){
    var seen = {};
    availableColors = [];
    variantMap.forEach(function(v){
      if(v.option1 && !seen[v.option1]){
        seen[v.option1] = true;
        availableColors.push(v.option1);
      }
    });
    document.querySelectorAll('.m-color-card').forEach(function(card){
      var colorVal = card.dataset.colorValue;
      var img = card.querySelector('img');
      if(colorVal && img){
        colorThumbs[colorVal] = img.getAttribute('src');
      }
    });
    var slotsEl = document.getElementById('m-slots');
    if(slotsEl && slotsEl.dataset.prefix) slotLabelPrefix = slotsEl.dataset.prefix;
  }

  // Read pack cards and build a map: qty -> pack data
  function buildPackMap(){
    var cards = document.querySelectorAll('.m-pack-card');
    if(!cards.length) return;
    var qtys = [];
    cards.forEach(function(card){
      var pq = parseInt(card.dataset.qty);
      if(isNaN(pq) || pq < 1) return;
      var variantId = card.dataset.variantId; // keep as string — Shopify variant IDs can exceed JS safe integer precision
      var v = null;
      for(var i = 0; i < variantMap.length; i++){
        if(variantMap[i].id === variantId){ v = variantMap[i]; break; }
      }
      packsByQty[pq] = {
        variantId: variantId,
        packValue: card.dataset.packValue,
        price: v ? v.price : 0,
        perUnit: v ? Math.round(v.price / pq) : 0
      };
      qtys.push(pq);
    });
    qtys.sort(function(a,b){ return a-b; });
    packQtyValues = qtys;
    if(qtys.length){
      minPackQty = qtys[0];
      maxPackQty = qtys[qtys.length - 1];
    }
  }

  function findVariant(color, pack){
    for(var i = 0; i < variantMap.length; i++){
      var v = variantMap[i];
      if(v.option1 === color && (pack === '' || v.option2 === pack)){
        return v;
      }
    }
    return null;
  }

  function applyVariant(v){
    if(!v) return;
    currentVariantId = v.id;
    currentVariantPrice = v.price;
    if(variantInput) variantInput.value = v.id;
    refreshTotal();
  }

  // Sync qty selector to match current pack
  function syncQtyFromPack(){
    if(!packQtyValues.length) return;
    // Find the qty that matches currentPack
    for(var q in packsByQty){
      if(packsByQty[q].packValue === currentPack){
        qty = parseInt(q);
        if(qtyEl) qtyEl.textContent = qty;
        updateQtyButtons();
        return;
      }
    }
  }

  // Find best pack for a given qty (exact match, else closest <=)
  function getPackForQty(targetQty){
    if(packsByQty[targetQty]) return packsByQty[targetQty];
    // No exact match: pick the largest pack <= targetQty (best discount per unit)
    var best = null;
    for(var i = 0; i < packQtyValues.length; i++){
      if(packQtyValues[i] <= targetQty){
        best = packsByQty[packQtyValues[i]];
      }
    }
    return best || packsByQty[packQtyValues[0]];
  }

  // When qty changes via +/- buttons, sync pack
  function syncPackFromQty(){
    if(!packQtyValues.length) return;
    var pack = getPackForQty(qty);
    if(!pack) return;
    currentPack = pack.packValue;

    // Update active pack card UI
    document.querySelectorAll('.m-pack-card').forEach(function(c){
      var isActive = c.dataset.packValue === currentPack;
      c.classList.toggle('m-pack-active', isActive);
      var radio = c.querySelector('input[type="radio"]');
      if(radio) radio.checked = isActive;
    });

    // Find variant for current color + new pack
    var v = findVariant(currentColor, currentPack);
    applyVariant(v);
  }

  function updateQtyButtons(){
    if(!qtyMinusBtn || !qtyPlusBtn) return;
    qtyMinusBtn.disabled = qty <= minPackQty;
  }

  // Render per-watch color slot pickers based on current qty
  function renderSlots(){
    var wrap = document.getElementById('m-slots');
    var list = document.getElementById('m-slots-list');
    if(!wrap || !list) return;
    if(qty < 2 || availableColors.length < 2){
      wrap.setAttribute('hidden','');
      list.innerHTML = '';
      closeSlotPopover();
      slotColors = [];
      return;
    }
    wrap.removeAttribute('hidden');
    var newSlots = [];
    for(var i = 0; i < qty; i++){
      newSlots[i] = (slotColors[i] && availableColors.indexOf(slotColors[i]) !== -1)
        ? slotColors[i]
        : currentColor;
    }
    slotColors = newSlots;
    var html = '';
    for(var s = 0; s < qty; s++){
      var c = slotColors[s];
      var thumb = colorThumbs[c] || '';
      html += '<button type="button" class="m-slot-card" data-slot-index="' + s + '">';
      html += '<span class="m-slot-thumb" data-slot-thumb="' + s + '">';
      if(thumb) html += '<img src="' + thumb + '" alt="' + escapeHtml(c) + '">';
      html += '</span>';
      html += '<span class="m-slot-body">';
      html += '<span class="m-slot-num">' + escapeHtml(slotLabelPrefix) + ' ' + (s + 1) + '</span>';
      html += '<span class="m-slot-color-name" data-slot-name="' + s + '">' + escapeHtml(c) + '</span>';
      html += '</span>';
      html += '<span class="m-slot-chevron">▾</span>';
      html += '</button>';
    }
    list.innerHTML = html;
    list.querySelectorAll('.m-slot-card').forEach(function(card){
      card.addEventListener('click', function(e){
        e.stopPropagation();
        var idx = parseInt(card.dataset.slotIndex);
        openSlotPopover(card, idx);
      });
    });
  }

  var activeSlotPopover = null;

  function closeSlotPopover(){
    if(activeSlotPopover){
      activeSlotPopover.remove();
      activeSlotPopover = null;
    }
    document.removeEventListener('click', closeSlotPopover);
  }

  function openSlotPopover(anchorCard, slotIndex){
    closeSlotPopover();
    var pop = document.createElement('div');
    pop.className = 'm-slot-popover';
    var html = '';
    for(var k = 0; k < availableColors.length; k++){
      var col = availableColors[k];
      var thumb = colorThumbs[col] || '';
      var isActive = col === slotColors[slotIndex];
      html += '<button type="button" class="m-slot-option' + (isActive ? ' m-slot-option-active' : '') + '" data-color="' + escapeHtml(col) + '">';
      html += '<span class="m-slot-option-thumb">';
      if(thumb) html += '<img src="' + thumb + '" alt="' + escapeHtml(col) + '">';
      html += '</span>';
      html += '<span class="m-slot-option-name">' + escapeHtml(col) + '</span>';
      if(isActive) html += '<span class="m-slot-option-check">✓</span>';
      html += '</button>';
    }
    pop.innerHTML = html;
    anchorCard.appendChild(pop);
    activeSlotPopover = pop;

    pop.querySelectorAll('.m-slot-option').forEach(function(opt){
      opt.addEventListener('click', function(e){
        e.stopPropagation();
        var color = opt.dataset.color;
        slotColors[slotIndex] = color;
        var thumbEl = document.querySelector('[data-slot-thumb="' + slotIndex + '"]');
        var nameEl = document.querySelector('[data-slot-name="' + slotIndex + '"]');
        var url = colorThumbs[color] || '';
        if(thumbEl) thumbEl.innerHTML = url ? '<img src="' + url + '" alt="' + escapeHtml(color) + '">' : '';
        if(nameEl) nameEl.textContent = color;
        closeSlotPopover();
        scheduleCartSync();
      });
    });

    setTimeout(function(){
      document.addEventListener('click', closeSlotPopover);
    }, 0);
  }

  function escapeHtml(s){
    return String(s).replace(/[&<>"']/g, function(c){
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function bindPacks(){
    document.querySelectorAll('.m-pack-card').forEach(function(card){
      card.addEventListener('click', function(e){
        e.preventDefault();
        document.querySelectorAll('.m-pack-card').forEach(function(c){ c.classList.remove('m-pack-active') });
        card.classList.add('m-pack-active');
        var radio = card.querySelector('input[type="radio"]');
        if(radio) radio.checked = true;
        currentPack = card.dataset.packValue;
        var v = findVariant(currentColor, currentPack);
        applyVariant(v);
        var pq = parseInt(card.dataset.qty);
        if(!isNaN(pq) && pq >= 1){
          qty = pq;
          if(qtyEl) qtyEl.textContent = qty;
          updateQtyButtons();
          renderSlots();
          refreshTotal();
        }
        scheduleCartSync();
      });
    });
  }

  function bindColors(){
    document.querySelectorAll('.m-color-card').forEach(function(card){
      card.addEventListener('click', function(){
        if(card.classList.contains('m-color-soldout')) return;
        document.querySelectorAll('.m-color-card').forEach(function(c){ c.classList.remove('m-color-active') });
        card.classList.add('m-color-active');
        currentColor = card.dataset.colorValue;
        var v = findVariant(currentColor, currentPack);
        applyVariant(v);
        filterGalleryByColor(currentColor);

        slotColors = [];
        renderSlots();

        var current = document.getElementById('m-color-current');
        if(current) current.innerHTML = '<em>' + currentColor + '</em>';
        if(stickyColorEl) stickyColorEl.textContent = currentColor.split(' ')[0];
        var galleryNameColor = document.getElementById('m-gallery-name-color');
        if(galleryNameColor) galleryNameColor.textContent = currentColor;
        scheduleCartSync();
      });
    });
  }

  function bindUpsell(){
    var toggle = document.getElementById('m-upsell-toggle');
    if(!toggle) return;
    upsellVariantId = toggle.dataset.variantId || '';
    upsellPrice = parseInt(toggle.dataset.price) || 0;
    upsellEnabled = !!toggle.checked;

    var qtyWrap = document.getElementById('m-upsell-qty');
    var qtyValEl = document.getElementById('m-upsell-qty-val');
    var minusBtn = document.getElementById('m-upsell-minus');
    var plusBtn = document.getElementById('m-upsell-plus');

    function syncQtyUI(){
      if(qtyValEl) qtyValEl.textContent = upsellQty;
      if(minusBtn) minusBtn.disabled = upsellQty <= 1;
    }
    function showQty(show){
      if(qtyWrap){ if(show){ qtyWrap.removeAttribute('hidden'); } else { qtyWrap.setAttribute('hidden',''); } }
    }

    toggle.addEventListener('change', function(){
      upsellEnabled = !!toggle.checked;
      if(upsellEnabled && upsellQty < 1) upsellQty = 1;
      showQty(upsellEnabled);
      syncQtyUI();
      refreshTotal();
      scheduleCartSync();
    });

    if(minusBtn){
      minusBtn.addEventListener('click', function(){
        if(upsellQty > 1){ upsellQty--; syncQtyUI(); refreshTotal(); scheduleCartSync(); }
      });
    }
    if(plusBtn){
      plusBtn.addEventListener('click', function(){
        upsellQty++; syncQtyUI(); refreshTotal(); scheduleCartSync();
      });
    }

    showQty(upsellEnabled);
    syncQtyUI();
  }

  // Calculate the displayed grand total.
  // Must match the Shopify Automatic Discounts that get applied at checkout:
  //   - qty=1: Pack 1 price ($99.900)
  //   - qty=2: Pack 2 price ($159.900) — Shopify applies fixed −$39.900 discount
  //   - qty=3+: Pack 1 × qty × 0.67 (33% off — Shopify integer-only discount)
  function calcWatchesTotal(){
    if(!packsByQty[1]){
      // Single-variant product (no pack option): fall back to price × qty
      return currentVariantPrice * qty;
    }
    var unitPrice = packsByQty[1].price;

    if(qty === 1){
      return unitPrice;
    }
    if(qty === 2 && packsByQty[2]){
      // Use the exact Pack 2 variant price (matches Shopify fixed-amount discount)
      return packsByQty[2].price;
    }
    if(qty >= 3){
      // 33% off Pack 1 × qty (matches Shopify percentage discount tier)
      return Math.round(unitPrice * qty * 0.67);
    }
    return unitPrice * qty;
  }

  function refreshTotal(){
    var grand = calcWatchesTotal();
    if(upsellEnabled && upsellPrice > 0) grand += upsellPrice * (upsellQty > 0 ? upsellQty : 1);
    if(ctaPriceEl) ctaPriceEl.textContent = fmt(grand);
    if(stickyPriceEl) stickyPriceEl.textContent = fmt(grand);
  }

  function bindViewers(){
    var el = document.getElementById('m-live-viewers');
    if(!el) return;
    var min = parseInt(el.dataset.min) || 4;
    var max = parseInt(el.dataset.max) || 12;
    if(min >= max) max = min + 1;
    function rand(a, b){ return Math.floor(Math.random() * (b - a + 1)) + a; }
    var current = rand(min, max);
    el.style.transition = 'opacity .3s ease';
    el.textContent = current;
    function tick(){
      var delta = Math.random() < 0.5 ? -1 : 1;
      var next = current + delta;
      if(next < min) next = min + 1;
      if(next > max) next = max - 1;
      if(next === current) next = current + (current < max ? 1 : -1);
      el.style.opacity = '0.35';
      setTimeout(function(){
        el.textContent = next;
        current = next;
        el.style.opacity = '1';
      }, 280);
      setTimeout(tick, 6000 + Math.random() * 8000);
    }
    setTimeout(tick, 3500 + Math.random() * 3500);
  }

  function bindCountdown(){
    var el = document.getElementById('m-countdown');
    if(!el) return;
    var minutes = parseInt(el.dataset.minutes) || 15;
    var persist = el.dataset.persist !== 'false';
    var STORAGE_KEY = 'monarca_countdown_deadline';
    var now = Date.now();
    var deadline;
    if(persist){
      try {
        var stored = parseInt(sessionStorage.getItem(STORAGE_KEY));
        if(stored && stored > now && (stored - now) <= minutes * 60 * 1000){
          deadline = stored;
        }
      } catch(e){}
    }
    if(!deadline){
      deadline = now + minutes * 60 * 1000;
      if(persist){
        try { sessionStorage.setItem(STORAGE_KEY, deadline); } catch(e){}
      }
    }
    function fmt(n){ return n < 10 ? '0' + n : '' + n; }
    function tick(){
      var remaining = deadline - Date.now();
      if(remaining <= 0){
        el.textContent = '00:00';
        el.style.animation = 'none';
        return;
      }
      var mins = Math.floor(remaining / 60000);
      var secs = Math.floor((remaining % 60000) / 1000);
      el.textContent = fmt(mins) + ':' + fmt(secs);
    }
    tick();
    setInterval(tick, 1000);
  }

  function bindVideos(){
    var videos = document.querySelectorAll('.m-videos .m-video');
    if(!videos.length) return;
    videos.forEach(function(v){
      v.addEventListener('play', function(){
        videos.forEach(function(other){
          if(other !== v && !other.paused) other.pause();
        });
      });
    });
  }

  function bindDescription(){
    var wrap = document.getElementById('m-desc-wrap');
    var btn = document.getElementById('m-desc-toggle');
    if(!wrap || !btn) return;
    var body = wrap.querySelector('.m-description-body');
    requestAnimationFrame(function(){
      if(body && body.scrollHeight <= wrap.clientHeight + 4){
        btn.setAttribute('hidden','');
        wrap.style.maxHeight = 'none';
        wrap.classList.add('m-expanded');
      }
    });
    btn.addEventListener('click', function(){
      var expanded = wrap.classList.toggle('m-expanded');
      btn.classList.toggle('m-expanded', expanded);
      btn.querySelector('.m-desc-toggle-label').textContent = expanded ? 'Ver menos' : 'Ver más';
    });
  }

  function normalizeColorKey(s){
    // Collapse whitespace and normalize spacing around slashes so
    // "Azul Royal/Plateado" and "Azul Royal / Plateado" match.
    return (s || '')
      .toLowerCase()
      .replace(/\s*\/\s*/g, '/')   // " / " -> "/"
      .replace(/\s+/g, ' ')
      .trim();
  }

  function slideMatchesColor(slide, color){
    var c = normalizeColorKey(color);
    if(!c) return true;
    var colors = (slide.dataset.colors || '').toLowerCase();
    var alt = (slide.dataset.alt || '').toLowerCase();
    var src = (slide.dataset.src || '').toLowerCase();
    if(colors === 'all' || colors === 'all|') return true;
    // Normalize each pipe-separated color token before comparing
    var tokens = colors.split('|');
    for(var i = 0; i < tokens.length; i++){
      if(tokens[i] && normalizeColorKey(tokens[i]) === c) return true;
    }
    if(alt && normalizeColorKey(alt).indexOf(c) !== -1) return true;
    var cSlug = c.replace(/[\s\/]+/g, '-');
    if(src && src.indexOf(cSlug) !== -1) return true;
    return false;
  }

  function filterGalleryByColor(color){
    var slides = document.querySelectorAll('.m-gallery-slide');
    if(!slides.length) return;

    var c = normalizeColorKey(color);
    var visible = 0;

    slides.forEach(function(s){
      var raw = (s.dataset.colors || '').toLowerCase();
      var match = false;

      if(!c){
        match = true;
      } else if(raw && raw !== 'all'){
        // Only images explicitly assigned to a variant color are considered.
        var tokens = raw.split('|');
        for(var i = 0; i < tokens.length; i++){
          if(tokens[i] && normalizeColorKey(tokens[i]) === c){ match = true; break; }
        }
      }
      s.style.display = match ? 'flex' : 'none';
      if(match) visible++;
    });

    // If the selected color has no assigned image at all, fall back to showing
    // every image (so the gallery is never empty).
    if(visible === 0){
      slides.forEach(function(s){ s.style.display = 'flex'; });
      visible = slides.length;
    }

    var totalEl = document.getElementById('m-gallery-total');
    if(totalEl) totalEl.textContent = visible;
    var currentEl = document.getElementById('m-gallery-current');
    if(currentEl) currentEl.textContent = '1';
    var track = document.getElementById('m-gallery-track');
    if(track) track.scrollLeft = 0;
  }

  function bindGallery(){
    var track = document.getElementById('m-gallery-track');
    var idxEl = document.getElementById('m-gallery-current');
    if(!track || !idxEl) return;
    var update = function(){
      var idx = Math.round(track.scrollLeft / track.clientWidth) + 1;
      idxEl.textContent = idx;
    };
    track.addEventListener('scroll', update, { passive: true });
    filterGalleryByColor(currentColor);
  }

  function bindFAQ(){
    document.querySelectorAll('.m-faq-q').forEach(function(q){
      q.addEventListener('click', function(){
        q.parentElement.classList.toggle('m-open');
        var toggle = q.querySelector('.m-faq-toggle');
        if(toggle) toggle.textContent = q.parentElement.classList.contains('m-open') ? '×' : '+';
      });
    });
  }

  function showToast(text){
    var t = document.getElementById('m-toast');
    if(!t) return;
    var txt = document.getElementById('m-toast-text');
    if(txt && text) txt.textContent = text;
    t.classList.add('m-toast-show');
    clearTimeout(showToast._tid);
    showToast._tid = setTimeout(function(){
      t.classList.remove('m-toast-show');
    }, 2400);
  }



  function bindMenuButton(){
    var btn = document.getElementById('m-menu-btn');
    var drawer = document.getElementById('m-menu-drawer');
    var closeBtn = document.getElementById('m-menu-close');
    var backdrop = document.getElementById('m-menu-backdrop');
    if(!btn || !drawer) return;

    function open(){
      drawer.classList.add('m-open');
      drawer.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
    }
    function close(){
      drawer.classList.remove('m-open');
      drawer.setAttribute('aria-hidden','true');
      document.body.style.overflow = '';
    }
    btn.addEventListener('click', function(e){ e.preventDefault(); open(); });
    if(closeBtn) closeBtn.addEventListener('click', close);
    if(backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape') close();
    });
  }

  function bindMainCta(){
    // Main CTA is now just a price display (Releasit's button sits below it).
    // No click handler needed.
  }

  function triggerReleasit(){
    var rsi = document.getElementById('rsi_buy_now_button');
    if(rsi){ rsi.click(); return true; }
    var anchor = document.getElementById('cart-wrapper') || document.getElementById('m-cta-anchor');
    if(anchor) anchor.scrollIntoView({behavior:'smooth', block:'center'});
    return false;
  }

  function bindSecondaryCTAs(){
    var finalBtn = document.getElementById('m-final-cta');
    if(finalBtn){
      finalBtn.addEventListener('click', function(e){
        e.preventDefault();
        triggerReleasit();
      });
    }
    var stickyBtn = document.getElementById('m-sticky-btn');
    if(stickyBtn){
      stickyBtn.addEventListener('click', function(e){
        e.preventDefault();
        triggerReleasit();
      });
    }
  }

  // ============ REAL-TIME CART SYNC ============
  // Instead of a custom "Add to cart" button, we keep the real Shopify cart
  // continuously in sync with the customer's PDP selection (pack, colors, qty,
  // upsell). This way, whenever the customer clicks Releasit's own button
  // (wherever/however it's rendered — even inside shadow DOM), the cart it
  // reads is always accurate. We never touch other products already in cart:
  // we only adjust the specific variant lines this component has added.
  var syncedVariantIds = {}; // variantId -> qty currently believed to be in cart (owned by us)
  var syncTimer = null;
  var syncInFlight = false;
  var syncQueued = false;

  function buildDesiredItems(){
    var desired = {};
    var hasPacks = packsByQty && packsByQty[1];
    if(hasPacks){
      var packValue = packsByQty[1].packValue;
      var colorsToAdd = [];
      if(qty === 1 || availableColors.length < 2){
        for(var i = 0; i < qty; i++){ colorsToAdd.push(currentColor); }
      } else {
        for(var j = 0; j < qty; j++){ colorsToAdd.push(slotColors[j] || currentColor); }
      }
      var counts = {};
      colorsToAdd.forEach(function(c){ counts[c] = (counts[c] || 0) + 1; });
      Object.keys(counts).forEach(function(color){
        var v = findVariant(color, packValue);
        if(v) desired[v.id] = (desired[v.id] || 0) + counts[color];
      });
      if(Object.keys(desired).length === 0){
        desired[packsByQty[1].variantId] = qty;
      }
    } else {
      // No pack selector — use current variant directly
      var vid = currentVariantId || (document.getElementById('m-variant-id') && document.getElementById('m-variant-id').value);
      if(vid) desired[vid] = qty;
    }

    var upsellToggle = document.getElementById('m-upsell-toggle');
    if(upsellToggle && upsellToggle.checked && upsellVariantId){
      desired[upsellVariantId] = upsellQty > 0 ? upsellQty : 1;
    }
    return desired;
  }

  function scheduleCartSync(){
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function(){
      if(syncInFlight){ syncQueued = true; return; }
      performCartSync();
    }, 450);
  }

  function performCartSync(callback){
    syncInFlight = true;
    var desired = buildDesiredItems();

    // Step 1: read the current cart to know what's actually there right now
    // (not just what we think is there — the customer may have removed items
    // in another tab, or an earlier /cart/change.js call may have silently
    // failed). This makes the sync self-healing.
    fetch('/cart.js', {headers: {'Accept': 'application/json'}})
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var currentInCart = {}; // variantId (string) -> qty
        (cart.items || []).forEach(function(item){
          currentInCart[String(item.id)] = item.quantity;
        });

        // Items to ADD (in desired but not in cart)
        var toAdd = [];
        Object.keys(desired).forEach(function(id){
          if(!currentInCart[id] && desired[id] > 0){
            toAdd.push({ id: id, quantity: desired[id] });
          }
        });

        // Items to UPDATE (change quantity or remove)
        var updates = {};
        Object.keys(currentInCart).forEach(function(id){
          var newQty = desired[id] || 0;
          if(currentInCart[id] !== newQty){
            updates[id] = newQty;
          }
        });
        // Also for desired items that already exist but at different qty
        Object.keys(desired).forEach(function(id){
          if(currentInCart[id] && currentInCart[id] !== desired[id]){
            updates[id] = desired[id];
          }
        });

        function doUpdates(next){
          if(Object.keys(updates).length === 0){ next(); return; }
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({ updates: updates })
          })
          .then(function(){ next(); })
          .catch(function(){ next(); });
        }

        function doAdds(next){
          if(toAdd.length === 0){ next(); return; }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({ items: toAdd })
          })
          .then(function(){ next(); })
          .catch(function(){ next(); });
        }

        // Do adds first so new items exist, then adjust quantities
        doAdds(function(){
          doUpdates(function(){
            syncedVariantIds = desired;
            syncInFlight = false;
            if(syncQueued){
              syncQueued = false;
              scheduleCartSync();
            }
            if(typeof callback === 'function') callback();
          });
        });
      })
      .catch(function(){
        syncInFlight = false;
        if(typeof callback === 'function') callback();
      });
  }

  // Legacy helper: kept for compatibility. Now just triggers Releasit's
  // button on the same PDP — no more /cart redirect.
  function goToPayment(){
    clearTimeout(syncTimer);
    function fire(){ triggerReleasit(); }
    if(syncInFlight){
      var wait = function(){
        if(syncInFlight){ setTimeout(wait, 100); return; }
        performCartSync(fire);
      };
      wait();
    } else {
      performCartSync(fire);
    }
  }

  function bindSticky(){
    if(!mainCtaEl || !stickyEl) return;
    window.addEventListener('scroll', function(){
      var r = mainCtaEl.getBoundingClientRect();
      if(r.bottom < -50){
        stickyEl.classList.add('m-visible');
      } else {
        stickyEl.classList.remove('m-visible');
      }
    }, { passive: true });
  }

  window.MonarcaPDP = {
    qty: function(d){
      var newQty = qty + d;
      if(newQty < minPackQty) newQty = minPackQty;
      qty = newQty;
      if(qtyEl) qtyEl.textContent = qty;
      updateQtyButtons();
      syncPackFromQty();
      renderSlots();
      refreshTotal();
      scheduleCartSync();
    }
  };

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
